import * as React from 'react';
import { useTranslation } from "react-i18next";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import Image from '../../../images/home/Raif Okt 18 Bestand.JPG';
import HS from '../../../images/HelgaSalchegger.png';

import Image_de from '../../../images/home/Startseite_neu_DE.png';
import Image_it from '../../../images/home/Startseite_neu IT.png';

export default function Beratungen() {

  const { t, i18n } = useTranslation();

  return (
    <div>
      <div className='unser' id="consulation">

        <Grid container spacing={0} alignItems='center'>

          <Grid item xs={12} md={6} lg={6} className='unser-textbox'>

            <Box sx={{
              fontWeight: 'bold',
            }}>
              {t('advise')}
            </Box>

            <Box sx={{ paddingBottom: 2 }} />

            <Grid container alignItems="center">

              <Grid item xs={12} sm={4} >
                <img src={HS} height={'200px'} alt="Helga Salchegger"></img>
              </Grid>

              <Grid item xs={12} sm={8}
                style={{
                  fontSize: '16pt',
                  verticalAlign: 'middle',
                  padding: '10px'
                }}>

                {t('salchegger')}
                <br />
                {t('salchegger_leader')}

              </Grid>


            </Grid>

          </Grid>


          <Grid item xs={12} md={6} lg={6} className='beratungen'>
            {i18n.language == "de" ?
              <img src={Image_de} className='beratungen-im' alt="IMG_1088" width='100%' />
              :
              <img src={Image_it} className='beratungen-im' alt="IMG_1088" width='100%' />
            }


          </Grid>
        </Grid>
      </div>

    </div>
  );
}